import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/hooks/useTrackEvent";

/**
 * Tracks every route change as a page_view event.
 * Place inside <BrowserRouter>.
 */
export const RouteTracker = () => {
  const location = useLocation();
  const lastPath = useRef<string>("");

  useEffect(() => {
    const path = location.pathname;
    if (path !== lastPath.current) {
      lastPath.current = path;
      trackPageView(path);
    }
  }, [location.pathname]);

  return null;
};
